import React from 'react'
import { useDispatch } from "react-redux";
import ShopIcon from '@material-ui/icons/Shop';
import ReplayIcon from '@material-ui/icons/Replay';
import { Button, Dialog, DialogContent, DialogTitle, Grid, IconButton, CircularProgress, TextField, Typography, DialogActions, InputAdornment } from '@material-ui/core'
import { IAMAction } from '../../actions'
import GoogleIcon from "../../assets/images/Google.svg";
import { ReactSVG } from "react-svg";

const TwoFactorSetup = ({ profile }) => {
    const dispatch = useDispatch()
    const [otpURL, setOtpURL] = React.useState('')
    const [otpURLStatus, setOtpURLStatus] = React.useState('NEW')
    const [userToken, setUsertoken] = React.useState('')
    const [verified, setVerified] = React.useState({locked: 0, status: 'SUCCESS', verified: false})
    const [verifiedStatus, setVerifiedStatus] = React.useState('NEW')

    const authenticatorURL = "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&gl=US&pli=1"

    const generateQR = () => IAMAction.twoFactor.generateSecret(profile.username, setOtpURL, setOtpURLStatus)

    const verifyQR = () => IAMAction.twoFactor.verify(profile.username, userToken, setVerified, setVerifiedStatus)

    React.useEffect(() => { if (profile.twofactor === 0) generateQR() }, [])

    React.useEffect(() => { if (verified.status === "SUCCESS" && verified.verified) IAMAction.autologin(dispatch) }, [verified])

    return (
        <Dialog open={profile.twofactor === 0} maxWidth="md">
            <React.Fragment>
                <DialogTitle><Typography variant='h3' color='textSecondary'>Two Factor Authentication</Typography></DialogTitle>
                <DialogContent>
                    <Grid container direction='column' justify='flex-start' alignItems='flex-start' spacing={2}>
                        <Grid item><Typography variant='h4' color='textSecondary'>Configure Google Authenticator</Typography></Grid>
                        <Grid item>
                            <Grid container direction='row' justify='flex-start' alignItems='center' spacing={2}>
                                <Grid item><Typography variant='h5' color='textSecondary'>1.&emsp;Install Google Authenticator (IOS - Android)</Typography></Grid>
                                <Grid item><IconButton size='small' href={authenticatorURL} target='_blank'><ShopIcon color='primary' /></IconButton></Grid>
                            </Grid>
                        </Grid>
                        <Grid item><Typography variant='h5' color='textSecondary'>2.&emsp;In the Google Authenticator app, select "+" icon.</Typography></Grid>
                        <Grid item>
                            <Grid container direction='column' justify='flex-start' alignItems='center' spacing={2}>
                                <Grid item><Typography variant='h5' color='textSecondary'>3.&emsp;Select "Scan a QR code" to scan this QR code.</Typography></Grid>
                                <Grid item><object data={otpURL} type="image/png" style={{ width: '200px', height: '200px', border: 'none' }}></object></Grid>
                                <Grid item style={{ marginLeft: 50 }}>
                                    <Grid container direction='row' justify='flex-start' alignItems='center' spacing={2}>
                                        <Grid item><Typography variant='h5' color='textSecondary'>Obtain a new QR</Typography></Grid>
                                        <Grid item><IconButton size='small' onClick={() => generateQR()}><ReplayIcon color={otpURLStatus === 'SUCCESS' ? 'primary' : 'secondary'} /></IconButton></Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container direction='column' justify='flex-start' alignItems='center' spacing={2}>
                                <Grid item><Typography variant='h5' color='textSecondary'>4.&emsp;Enter OTP from Google Authenticator</Typography></Grid>
                                <Grid item><TextField autoFocus variant='outlined' fullWidth InputProps={{ startAdornment: <InputAdornment style={{ "paddingTop": "5px" }} position="start"><ReactSVG src={GoogleIcon} /></InputAdornment> }} size='small' type='number' value={userToken} onChange={(event) => setUsertoken(event.target.value)} /></Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions><Button variant='contained' disabled={userToken.length !== 6} color='primary' onClick={verifyQR} startIcon={verifiedStatus === 'WORKING' ? <CircularProgress size={25} /> : null}><Typography variant='h5' color='textSecondary'>Verify OTP</Typography></Button></DialogActions>
            </React.Fragment>
        </Dialog >
    )
}

export default TwoFactorSetup
